import React from 'react';
import {
  Box, Group, Stack, Text, Tooltip,
} from '@mantine/core';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { icon } from '@fortawesome/fontawesome-svg-core/import.macro';
import LinkListField from '../shared/LinkListField';

/**
 * Les deux liens que le site publié ajoute de lui-même.
 *
 * Ils ne sont **pas** dans la valeur du champ : les stocker les rendrait
 * supprimables, renommables et redirigeables. Ils sont affichés ici en lecture
 * seule pour que l'utilisateur sache qu'ils existeront, plutôt que de les
 * découvrir en production ou de croire à un bug.
 */
const MANDATORY_LINKS = ['Politique cookies', 'Gérer mes cookies'];

const MANDATORY_HINT = "Ajoutés automatiquement au pied de page du site publié, "
  + "après vos liens. La loi impose un accès permanent à la politique cookies et "
  + "un moyen de retirer son consentement aussi simple que de le donner : ils ne "
  + 'peuvent être ni supprimés, ni renommés, ni déplacés. Ils prennent le style '
  + "de vos autres liens, sauf si le contraste avec le fond est insuffisant.";

/** Champ « Liens » du footer — liste repliable partagée. */
export default function SiteFooterLinksField({ value, onChange }) {
  return (
    <Stack gap={4}>
      <LinkListField value={value} onChange={onChange} />

      <Group gap={4} align="center" mt={6}>
        <Text size="10px" c="dimmed" tt="uppercase" fw={600}>
          Ajoutés automatiquement
        </Text>
        <Tooltip label={MANDATORY_HINT} multiline w={280} withArrow>
          <FontAwesomeIcon
            icon={icon({ name: 'circle-info', style: 'light' })}
            style={{ fontSize: 14, display: 'block', color: 'var(--mantine-color-gray-6)' }}
            aria-label="Pourquoi ces liens ne sont pas modifiables"
          />
        </Tooltip>
      </Group>

      {/* Volontairement sans poignée, sans corbeille et sans chevron : rien à
          saisir, rien à ouvrir. Le trait discontinu dit qu'on ne les manipule
          pas, sans avoir à le lire. */}
      {MANDATORY_LINKS.map((label) => (
        <Box
          key={label}
          style={{
            border: '1px dashed var(--mantine-color-gray-4)',
            borderRadius: 6,
            backgroundColor: 'var(--mantine-color-gray-0)',
            cursor: 'default',
          }}
        >
          <Group p={6} gap={4} wrap="nowrap">
            <Text size="sm" c="dimmed" truncate>{label}</Text>
          </Group>
        </Box>
      ))}
    </Stack>
  );
}
